import {createFileRoute, redirect} from '@tanstack/react-router'

export const Route = createFileRoute('/dispatch-timeline')({
    beforeLoad: () => {
        throw redirect({to: '/dispatch'})
    },
})
